import type { SchemaEuropaceProcessEvent } from 'cpool-schemas';
import { useTranslation } from 'react-i18next';

type Props = {
    document: NonNullable<SchemaEuropaceProcessEvent['documents']>[number];
};

export const Document: React.FC<Props> = ({ document }) => {
    const { t } = useTranslation();
    if (!document.displayName && !document.uri) return null;

    const label =
        document.displayName || t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.DEFAULT_DOCUMENT_NAME');

    if (!document.uri)
        return (
            <li className="flex gap-1.5">
                <span className="shrink-0 select-none">–</span>
                <span>{label}</span>
            </li>
        );
    return (
        <li className="flex gap-1.5">
            <span className="shrink-0 select-none">–</span>
            <a href={document.uri} target="_blank" rel="noopener noreferrer" className="text-blue underline">
                {label}
            </a>
        </li>
    );
};
